// the page and its query hook must prune the url with the same allowlist
export const TALK_STATS_PARAMS = ['terms', 'sort', 'desc'];

// the nine most recent prophets, newest first
export const DEFAULT_TERMS = [
  'Dallin H. Oaks',
  'Russell M. Nelson',
  'Thomas S. Monson',
  'Gordon B. Hinckley',
  'Howard W. Hunter',
  'Ezra Taft Benson',
  'Spencer W. Kimball',
  'Harold B. Lee',
  'Joseph Fielding Smith',
];
